import {getDetailByLatLng} from '../api/getDetailByLatLng';
import store from '~/store';
import {loadsSearch} from '~/modules/loadsSearch/actions';
import {coerceQueryTypes} from './search';
import {geoAndGetdetail} from '~/modules/geosearch/actions.js';

const isWeb = () => {
  const ua = navigator.userAgent;
  if (window.navigator.userAgent.replace(/\s/g, '') !== '') {
    if ((/android|webos|ip(hone|ad|od)|opera (mini|mobi|tablet)|iemobile|windows.+(phone|touch)|mobile|fennec|kindle (Fire)|Silk|maemo|blackberry|playbook|bb10\; (touch|kbd)|Symbian(OS)|Ubuntu Touch/i.test(ua))) {
      return false;
    }
  }
  return true;
};

const anywhereLoads = () => {
  let currentTimestamp = new Date().setHours(0, 0, 0, 0);
  let add1timestamp = currentTimestamp + 1 * 24 * 60 * 60 * 1000;
  let add2timestamp = currentTimestamp + 2 * 24 * 60 * 60 * 1000;
  let add3timestamp = currentTimestamp + 3 * 24 * 60 * 60 * 1000;
  let add4timestamp = currentTimestamp + 4 * 24 * 60 * 60 * 1000;
  let add5timestamp = currentTimestamp + 5 * 24 * 60 * 60 * 1000;
  let add6timestamp = currentTimestamp + 6 * 24 * 60 * 60 * 1000;

  const query = {
    from_city: null,
    from_state: null,
    from_country: null,
    from_lng: null,
    from_lat: null,
    from_name: null,
    limit: 50,
    offset: 0,
    loadSize: 'full',
    show_option: 'All',
    sort_by: 'age',
    sort_order: 'asc',
    dho: 200,
    date: [
      new Date(currentTimestamp),
      new Date(add1timestamp),
      new Date(add2timestamp),
      new Date(add3timestamp),
      new Date(add4timestamp),
      new Date(add5timestamp),
      new Date(add6timestamp)
    ]
  }
  store.dispatch(loadsSearch(coerceQueryTypes(query)));
}

export const getGeolocation = () => {
  if (navigator.geolocation && (location.pathname == '/' || !location.pathname) && !isWeb()) {
    navigator.geolocation.getCurrentPosition(showPosition, showError);
  } else if ((location.pathname == '/' || !location.pathname) && !isWeb()) {
    anywhereLoads();
  }
}
const showPosition = (position) => {
  let currentTimestamp = new Date().setHours(0, 0, 0, 0);
  let add1timestamp = currentTimestamp + 1 * 24 * 60 * 60 * 1000;
  let add2timestamp = currentTimestamp + 2 * 24 * 60 * 60 * 1000;
  let add3timestamp = currentTimestamp + 3 * 24 * 60 * 60 * 1000;
  let add4timestamp = currentTimestamp + 4 * 24 * 60 * 60 * 1000;
  let add5timestamp = currentTimestamp + 5 * 24 * 60 * 60 * 1000;
  let add6timestamp = currentTimestamp + 6 * 24 * 60 * 60 * 1000;
  if (!position || !position.coords.latitude) {
    anywhereLoads();
  } else {
    getDetailByLatLng(store.getState, {
      lat: position.coords.latitude,
      lng: position.coords.longitude
    }).then((data) => {
      const query = {
        from_city: data.address_components && data.address_components[0] && data.address_components[0].short_name,
        from_state: data.address_components && data.address_components[1] && data.address_components[1].short_name,
        from_country: data.address_components && data.address_components[2] && data.address_components[2].short_name,
        from_lng: data.lng,
        from_lat: data.lat,
        from_name: `${data.formatted_address.split(',')[0]}, ${data.formatted_address.split(',')[1]}`,
        limit: 50,
        offset: 0,
        loadSize: 'full',
        show_option: 'All',
        sort_by: 'age',
        sort_order: 'asc',
        dho: 200,
        date: [
          new Date(currentTimestamp),
          new Date(add1timestamp),
          new Date(add2timestamp),
          new Date(add3timestamp),
          new Date(add4timestamp),
          new Date(add5timestamp),
          new Date(add6timestamp)
        ]
      }
      store.dispatch(loadsSearch(coerceQueryTypes(query)));
    });
  }
}

const showError = (error) => {
  anywhereLoads();
  switch (error.code) {
    case error.PERMISSION_DENIED:
      console.log("User denied the request for Geolocation.")
      break;
    case error.POSITION_UNAVAILABLE:
      console.log("Location information is unavailable.")
      break;
    case error.TIMEOUT:
      console.log("The request to get user location timed out.")
      break;
    case error.UNKNOWN_ERROR:
      console.log("An unknown error occurred.")
      break;
  }
}



// WEBPACK FOOTER //
// ./src/misc/geolocation.js